<template>
    <div class="index" id="wrapper" style="margin-top:0;">
    <app-header />
    <section class="section-1" id="huan10_42" style="overflow: hidden;">
      <div class="content-1 zedit">
        <h3>人体多模态生物特,征融合认知计算技术</h3>
        <!-- <h3>助力智能认知诊断　为健康管理赋能</h3> -->
        <p>为用户提供智能化“望、闻、问、切”以及个性化、精准的疾病和健康方面的解决方案</p>
      </div>
      <div id="canvas"></div>
    </section>
    <div id="main">
      <div class="page_news">
        <div class="page_news_list" id="dataList">
          <left>
            <dl>
              <a href="javascript:;">
                <img src="../assets/images/article/news-15.jpg">
                <h2>
                  <b>以城市智脑发展战略为基础 开启时空大数据建设新模式</b>
                  <c>2017年9月15日，北京中润普达信息技术有限公司（以下简称“中润普达”）与北京都在哪智慧城市科技有限公司（以下简称“都在哪”）战略合作签约仪式在京顺利举行。中润普达CEO杜小军、董事会秘书杜乐、销售总监郭海斌、北京都在哪智慧城市科技有限公司总经理吴余龙、副总经理时文菁、总经理助理蒋梓玉、市场总监毕梦华等相关领导出席了签约仪式。双方将基于共同认可的城市智脑发展战略，即发展基于精准位置服务的智慧城市大数据服务，通过三体（技术共同体，应用联合体，服务综合体），三百（百家企业，百城智脑，百亿基金），三年计划，基于城市智脑以及整合数据资源推动N个应用的1+N商业模式。都在哪以时空大数据协同创新中心全球剖分网格编码与时空网格数据容器为核心技术，发挥智慧城市网格于新型智慧城市北斗网格标识服务体系与城市智脑建设优...</c>
                  <g onclick="">&nbsp;</g>
                  <e>2018-02-07 17:17:49</e>
                </h2>
              </a>

              <a href="javascript:;">
                <img src="../assets/images/article/news-23.jpg">
                <h2>
                  <b>杜小军受邀参加IAIS2017国际人工智能产业峰会</b>
                  <c>为期两天的2017中国·光谷国际人工智能产业峰会在武汉圆满落幕。本届峰会汇聚了众多中外知名专家、企业家、投资家，对人工智能的发展趋势、产业政策、前沿技术和应用、行业痛点进行了深入探讨。11月18日至19日，为期两天的2017中国·光谷国际人工智能产业峰会在武汉圆满落幕。本届峰会汇聚了众多中外知名专家、企业家、投资家，对人工智能的发展趋势、产业政策、前沿技术和应用、行业痛点进行了深入探讨。北京中润普达（集团）公司总裁、武汉东湖大数据交易中心总经理杜小军作为受邀嘉宾出席大会并发表主题演讲。19日上午，杜小军发表了题为《基于认知矩阵计算技术的城市综合治理创新模式》的演讲。在演讲中，杜小军首先介绍了当今城市化即将面临的困难和挑战，以及中文认知计算在其中的关键性作用，他表示，中文认知技术的突破将推动全球人工智能...</c>
                  <g onclick="">&nbsp;</g>
                  <e>2018-02-07 17:17:07</e>
                </h2>
              </a>

              <a href="javascript:;">
                <img src="../assets/images/article/news-22.jpg">
                <h2>
                  <b>中润普达实现汉语语义机器识别技术突破 机器人或能“读心”</b>
                  <c>新华网武汉１２月８日电（记者冯国栋）长期以来，计算机对汉语语义的识别一直停留“字面”层面。由于语言博大精深，在日常交流的不同语境下，同一词或短语的语义以及语言背后的动机和意图，都可能会大相径庭。如何让计算机“听懂”汉语，是我国科研人员攻克的技术难点。日前，国内综合大数据人工智能公司“中润普达”宣布，公司在基于大数据的中文“认知矩阵”和“动态平衡模型”计算技术上实现突破，将有效提升计算机对自然条件下的汉语语义识别的准确率。中润普达集团执行总裁杜小军说，通俗讲，要让计算机“听懂”人话，要在“听”和“懂”两方面破题。在“听”的环节，首先需要让计算机排除汉语方言和说话者个人因素的干扰，准确捕捉到说话者的发出的每一个音节，通过音节组合准确锁定对应的词语，并在数据库中调取词语相关解释。目前这一层面的技...</c>
                  <g onclick="">&nbsp;</g>
                  <e>2018-02-07 17:16:35</e>
                </h2>
              </a>

              <a href="javascript:;">
                <img src="../assets/images/article/news-2.jpg">
                <h2>
                  <b>中科大学者实现新型量子密钥分配研究协议，提升安全性能</b>
                  <c>记者从中国科学技术大学获悉，该校中科院量子信息重点实验室近期在环回差分相位量子密钥分配（RRDPS）研究方面取得重要进展，银振强、王双、陈巍、韩正甫等人在理论上完善了该协议的安全性证明，以此为基础实现了分组脉冲数最小、安全距离最长的RRDPS协议，解决了该协议在实际信道条件下分组脉冲数过多、效率偏低的问题。国际学术期刊《自然·通讯》日前发表了该成果。RRDPS是日本和美国科学家2014年提出的新型量子密钥分发协议，无需监测信号扰动参数，即可实现对窃听者信息量的估计，在实际应用中也具有系统简化、误码率容忍高等优势。但该协议仍存在一些关键问题没有解决，不能定量描述窃听者攻击行为、系统误码率和信息泄露的内在关系，实现的装置复杂限制了实用化。为解决这些问题，韩正甫研究组的银振强、王双和陈巍等人首先在理论上完善了RRDPS...</c>
                  <g onclick="window.open('http://www.thepaper.cn/newsDetail_forward_1986081');">阅读全文 &gt;</g>
                  <e>2018-02-07 14:49:46</e>
                </h2>
              </a>
            </dl>
          </left>
        </div>
      </div>
    </div>
    <app-footer />
  </div>
</template>

<script>
import header from '@/components/header'
import footer from '@/components/footer'



export default {
  data () {
    return {

    }
  },
  components: {
    'app-header': header,
    'app-footer': footer,
  },
  methods: {
    returnGo () {
      this.$router.go(0);
    },
    Scroll () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 400) {
        //$('.header-1').fadeIn("slow");
        $(".pageScroll").addClass("pageshow");
      } else if (scrollTop < 400) {
        $(".pageScroll").removeClass("pageshow");
      }
    },
  },
  mounted () {
    var navLabel = new Array('平台', '产品', "芯片");
    $('#main').pageScroller({ navigation: navLabel });
    $('.next').click(function (e) {
      e.preventDefault();
      pageScroller.next();
    });
    $('.prev').click(function (e) {
      e.preventDefault();
      pageScroller.prev();
    });

    document.addEventListener('scroll', this.Scroll, true);
    $(".z-ai-tab span").click(function () {
      $(".z-ai-tab span").eq($(this).index()).addClass("active").siblings().removeClass('active');
      $(".z-ai-list").eq($(".z-ai-tab span").index(this)).addClass("zshow").siblings().removeClass('zshow');
    });
    var jq = $;


    jq.fn.banqh = function (can) {
      can = jq.extend({
        picwrap: null,//总框架
        pic: null,//大图框架
        pnum: null,//小图框架
        prev_btn: null,//小图左箭头
        next_btn: null,//小图右箭头
        pop_prev: null,//弹出框左箭头
        pop_next: null,//弹出框右箭头
        //delayTime:800,//切换一张图片时间
        order: 0,//当前显示的图片（从0开始）
        picdire: true,//大图滚动方向（true水平方向滚动）
        mindire: true,//小图滚动方向（true水平方向滚动）
        min_picnum: null,//小图显示数量
      }, can || {});
      var picnum = jq(can.pic).find('ul li').length;
      var picw = jq(can.pic).find('ul li').outerWidth(true);
      var pich = jq(can.pic).find('ul li').outerHeight(true);
      var picminnum = jq(can.pnum).find('ul li').length;
      var picminw = jq(can.pnum).find('ul li').outerWidth(true);
      var picminh = jq(can.pnum).find('ul li').outerHeight(true);
      var tpqhnum = 0;
      var xtqhnum = 0;
      jq(can.pic).find('ul').width(picnum * picw);
      jq(can.pnum).find('ul').width(picminnum * picminw);

      //点击小图切换大图
      jq(can.pnum).find('li').click(function () {
        tpqhnum = xtqhnum = jq(can.pnum).find('li').index(this);
        show(tpqhnum);
        minshow(xtqhnum);
      }).eq(can.order).trigger("click");

      //小图左右      
      jq(can.prev_btn).click(function () {
        if (tpqhnum == 0) { tpqhnum = picnum };
        if (xtqhnum == 0) { xtqhnum = picnum };
        xtqhnum--;
        tpqhnum--;
        show(tpqhnum);
        minshow(xtqhnum);
      })
      jq(can.next_btn).click(function () {
        if (tpqhnum == picnum - 1) { tpqhnum = -1 };
        if (xtqhnum == picminnum - 1) { xtqhnum = -1 };
        xtqhnum++;
        minshow(xtqhnum)
        tpqhnum++;
        show(tpqhnum);
      })

      //小图切换
      function minshow (xtqhnum) {
        var mingdjl_num = xtqhnum - can.min_picnum + 2
        var mingdjl_w = -mingdjl_num * picminw;
        var mingdjl_h = -mingdjl_num * picminh;

        if (can.mindire == true) {
          //jq(can.pnum).find('ul li').css('float','left');
          if (picminnum > can.min_picnum) {
            if (xtqhnum < 4) { mingdjl_w = 0; }
            if (xtqhnum == picminnum - 1) { mingdjl_w = -(mingdjl_num - 1) * picminw; }
            jq(can.pnum).find('ul').stop().animate({ 'left': mingdjl_w }, can.delayTime);
          }

        } else {
          jq(can.pnum).find('ul li').css('float', 'none');
          if (picminnum > can.min_picnum) {
            if (xtqhnum < 4) { mingdjl_h = 0; }
            if (xtqhnum == picminnum - 1) { mingdjl_h = -(mingdjl_num - 1) * picminh; }
            jq(can.pnum).find('ul').stop().animate({ 'top': mingdjl_h }, can.delayTime);
          }
        }

      }
      //大图切换
      function show (tpqhnum) {
        var gdjl_w = -tpqhnum * picw;
        var gdjl_h = -tpqhnum * pich;
        if (can.picdire == true) {
          //jq(can.pic).find('ul li').css('float','left');
          jq(can.pic).find('ul').stop().animate({ 'left': gdjl_w }, can.delayTime);
        } else {
          jq(can.pic).find('ul').stop().animate({ 'top': gdjl_h }, can.delayTime);
        }//滚动
        //jq(can.pic).find('ul li').eq(tpqhnum).fadeIn(can.delayTime).siblings('li').fadeOut(can.delayTime);//淡入淡出
        jq(can.pnum).find('li').eq(tpqhnum).addClass("on").siblings(this).removeClass("on");
      };
    }




    jq('#proinfo').banqh({
      picwrap: "#proinfo",//总框架
      pic: "#ban_pic1",//大图框架
      pnum: "#ban_num1",//小图框架
      prev_btn: "#prev_btn1",//小图左箭头
      next_btn: "#next_btn1",//小图右箭头
      order: 0,//当前显示的图片（从0开始）
      min_picnum: 6,//小图显示数量
    })

    $('.cont-list li').hover(function () {
      $('.cont-list-main', this).stop().animate({
        height: '280px'
      });
    }, function () {
      $('.cont-list-main', this).stop().animate({
        height: '0'
      });
    });






  },
}
</script>

<style>
@import "../assets/css/product.css";

@import "./../assets/css/page.css";
@import "./../assets/css/ystep.css";
#huan10_42 {
  background: url(../assets/img/banner_img42.jpg) center no-repeat;
}
.page_news_list left dl a h2 e {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/news.vue